/**
 * Dummy class with no-op implementations of the WebStore interface.
 * This is used for server side safety, as neither LocalStorage or IndexedDB
 * should run on the server.
 */
export class NoOpStorage {
    async clear() {
        return undefined;
    }
    async get() {
        return undefined;
    }
    async getMany() {
        return undefined;
    }
    async isExpired() {
        return undefined;
    }
    async remove() {
        return undefined;
    }
    async set() {
        return undefined;
    }
    async getAllKeys() {
        return undefined;
    }
}
